import { render, staticRenderFns } from "./Typing.vue?vue&type=template&id=3952c832&scoped=true"
import script from "./Typing.vue?vue&type=script&lang=js"
export * from "./Typing.vue?vue&type=script&lang=js"
import style0 from "./Typing.vue?vue&type=style&index=0&id=3952c832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952c832",
  null
  
)

export default component.exports